// import React from 'react';
// import { 
//   Rocket, ShieldCheck, Users, Lightbulb, 
//   ChevronLeft, Award, HelpCircle, FileSignature, 
//   Coins, Scale 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';
// export default function StartupsLegalServices() {
  
//   // Core startup legal support modules
//   const startupServices = [
//     {
//       title: "التأسيس والترخيص الاستثماري",
//       desc: "اختيار الكيان القانوني الأمثل وصياغة عقود التأسيس، واستخراج تراخيص وزارة الاستثمار (MISA) وتراخيص الحاضنات للمشاريع التقنية والمبتكرة.",
//       icon: <Rocket className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "اتفاقيات المؤسسين وحوكمة الشركاء",
//       desc: "صياغة اتفاقيات الشركاء (Founders' Agreements) التي تنظم نسب الملكية، شروط المغادرة، آليات اتخاذ القرار، وحقوق الشفعة لمنع الخلافات المستقبليّة.",
//       icon: <Users className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "جولات التمويل ورأس المال الجريء",
//       desc: "هيكلة ومراجعة مستندات الاستثمار الجريء (Venture Capital) وصياغة عقود التمويل المبسطة (SAFE) والسندات القابلة للتحويل إلى أسهم.",
//       icon: <Coins className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "حماية الملكية الفكرية والأصول",
//       desc: "تسجيل العلامات التجارية، براءات الاختراع، وحقوق المؤلف لدى الهيئة السعودية للملكية الفكرية، وصياغة اتفاقيات عدم الإفصاح (NDA).",
//       icon: <Lightbulb className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-slate-50 text-right font-sans" dir="rtl">
      
//       <ServicePageHeader 
//         title="خدمات الشركات الناشئة وريادة الأعمال"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">البيئة القانونية للابتكار والنمو</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات الشركات الناشئة وريادة الأعمال</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نحن لا نكتفي بتقديم الاستشارات التقليدية؛ بل نشكل الشريك القانوني الاستراتيجي الذي يحمي فكرتك، ويهيكل جولاتك التمويلية، ويؤمن انطلاقتك التجاريّة في السوق السعودي وفق أعلى معايير الحوكمة.
//           </p>
//         </div>
//       </section>

//       {/* Analytical Value Proposition */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100 flex flex-col lg:flex-row gap-12 items-center">
//           <div className="flex-1">
//             <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-6 leading-tight">
//               بناء الأساس القانوني الصحيح يحمي شركتك من عثرات البداية
//             </h2>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
//               تواجه الكثير من الشركات الناشئة خطر الفشل لا بسبب ضعف الفكرة الاستثمارية، بل نتيجة غياب الصياغة القانونية السليمة للعلاقة بين المؤسسين، أو إهمال حماية الأصول الفكرية والتقنية في المراحل المبكرة.
//             </p>
//             <p className="text-gray-600 text-base md:text-lg leading-relaxed">
//               في مكتبنا، نعمل جنباً إلى جنب مع رواد الأعمال والمستثمرين الملائكيين وصناديق رأس المال الجريء. نساعدك على فهم متطلبات نظام الشركات الجديد، وتصميم خطط تحفيز الموظفين بالأسهم (ESOP)، وتجهيز شركتك قانونياً لاجتياز الفحص النافي للجهالة قبل دخول أي جولة استثمارية.
//             </p>
//           </div>
          
//           {/* Quick Core Benefits Box */}
//           <div className="w-full lg:w-80 bg-slate-900 text-white p-6 rounded-xl border border-slate-800 space-y-4 shadow-lg">
//             <h3 className="font-bold text-amber-500 text-base flex items-center gap-2">
//               <ShieldCheck className="w-5 h-5" /> حلول مرنة للمشاريع الواعدة:
//             </h3>
//             <ul className="space-y-3 text-xs text-slate-300">
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>مواءمة كاملة مع تنظيمات هيئة السوق المالية.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>هيكلة مرنة لأسهم الموظفين والخيارات المستقبلية.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>حماية فكرية للمصنفات البرمجية والنماذج الصناعية.</span>
//               </li>
//               <li className="flex items-center gap-2">
//                 <Award className="w-4 h-4 text-amber-500 shrink-0" />
//                 <span>صياغة عقود تقديم الخدمات وشروط الاستخدام الرقمية.</span>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Grid: Scope of Services */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">حزمة الرعاية القانونية الشاملة للرياديين</h2>
//             <p className="text-slate-400 max-w-xl mx-auto">من صياغة الفكرة الأولية وتأمين العقود وحتى التوسع وعقد صفقات الاستحواذ والاندماج</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {startupServices.map((service, index) => (
//               <div key={index} className="bg-slate-800/60 p-8 rounded-xl border border-slate-700 hover:border-amber-500 transition-all duration-300">
//                 <div className="bg-slate-700/50 p-3 rounded-lg w-fit mb-5">
//                   {service.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-100 mb-2">{service.title}</h3>
//                 <p className="text-slate-400 text-sm leading-relaxed">{service.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Regulatory Context Disclaimer / Tip */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <HelpCircle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">نصيحة ريادية بشأن عقود الدخول في الاستثمار:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               عند التفاوض على شروط وثيقة الشروط الأساسية (Term Sheet) مع المستثمرين، يجب الالتفات الدقيق لبعض البنود المصيرية مثل بنود تصفية الأفضلية (Liquidation Preference) وحقوق مكافحة التخفيف (Anti-dilution). إن التوقيع المتسرع دون مراجعة محامٍ متخصص قد يحرم المؤسسين من ثمار جهودهم عند التخارج.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* Call to Action Banner */}
//       <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
//         <div className="inline-flex p-3 bg-slate-100 rounded-full text-slate-800 mb-4">
//           <FileSignature className="w-6 h-6" />
//         </div>
//         <h3 className="text-xl font-bold text-slate-800 mb-2">هل تبحث عن انطلاقة قانونية آمنة لمشروعك؟</h3>
//         <p className="text-gray-500 text-sm max-w-xl mx-auto mb-6">
//           شاركنا طبيعة مشروعك الناشئ والتحديات التي تواجهها، ودع فريقنا المتخصص يتولى بناء الإطار التشريعي والحمائي الذي يضمن لك نمواً مستداماً.
//         </p>
//         <button className="bg-amber-600 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-amber-700 transition-colors shadow-md inline-flex items-center gap-2">
//           طلب باقة الدعم القانوني للشركات الناشئة
//           <ChevronLeft className="w-4 h-4" />
//         </button>
//       </section>

//     </div>
//   );
// }


import React from 'react';
import { 
  Rocket, ShieldCheck, Users, Lightbulb, 
  ChevronLeft, Award, HelpCircle, FileSignature, 
  Coins, Scale 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';
import { openWhatsApp } from '../utils';

export default function StartupsLegalServices() {
  
  // Core startup legal support modules - Refactored to Navy Light
  const startupServices = [
    {
      title: "التأسيس والترخيص الاستثماري",
      desc: "اختيار الكيان القانوني الأمثل وصياغة عقود التأسيس، واستخراج تراخيص وزارة الاستثمار (MISA) وتراخيص الحاضنات للمشاريع التقنية والمبتكرة.",
      icon: <Rocket className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "اتفاقيات المؤسسين وحوكمة الشركاء",
      desc: "صياغة اتفاقيات الشركاء (Founders' Agreements) التي تنظم نسب الملكية، شروط المغادرة، آليات اتخاذ القرار، وحقوق الشفعة لمنع الخلافات المستقبليّة.",
      icon: <Users className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "جولات التمويل ورأس المال الجريء",
      desc: "هيكلة ومراجعة مستندات الاستثمار الجريء (Venture Capital) وصياغة عقود التمويل المبسطة (SAFE) والسندات القابلة للتحويل إلى أسهم.",
      icon: <Coins className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "حماية الملكية الفكرية والأصول",
      desc: "تسجيل العلامات التجارية، براءات الاختراع، وحقوق المؤلف لدى الهيئة السعودية للملكية الفكرية، وصياغة اتفاقيات عدم الإفصاح (NDA).",
      icon: <Lightbulb className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      
      <ServicePageHeader 
        title="خدمات الشركات الناشئة وريادة الأعمال"
        description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">البيئة القانونية للابتكار والنمو</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات الشركات الناشئة وريادة الأعمال</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نحن لا نكتفي بتقديم الاستشارات التقليدية؛ بل نشكل الشريك القانوني الاستراتيجي الذي يحمي فكرتك، ويهيكل جولاتك التمويلية، ويؤمن انطلاقتك التجاريّة في السوق السعودي وفق أعلى معايير الحوكمة.
          </p>
        </div>
      </section>

      {/* Analytical Value Proposition */}
    {/* Analytical Value Proposition - Optimized Responsive Desktop Layout */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-slate-200/60 flex flex-col lg:flex-row gap-8 lg:gap-12 items-center lg:items-stretch">
          
          {/* Main Text Content */}
          <div className="flex-1">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              بناء الأساس القانوني الصحيح يحمي شركتك من عثرات البداية
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              تواجه الكثير من الشركات الناشئة خطر الفشل لا بسبب ضعف الفكرة الاستثمارية، بل نتيجة غياب الصياغة القانونية السليمة للعلاقة بين المؤسسين، أو إهمال حماية الأصول الفكرية والتقنية في المراحل المبكرة.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              في مكتبنا، نعمل جنباً إلى جنب مع رواد الأعمال والمستثمرين الملائكيين وصناديق رأس المال الجريء. نساعدك على فهم متطلبات نظام الشركات الجديد، وتصميم خطط تحفيز الموظفين بالأسهم (ESOP)، وتجهيز شركتك قانونياً لاجتياز الفحص النافي للجهالة قبل دخول أي جولة استثمارية.
            </p>
          </div>
          
          {/* Quick Core Benefits Box - Fixed Fixed-Width bug on Desktop */}
          <div className="w-full lg:w-96 lg:max-w-md shrink-0 bg-indigo-950 text-white p-8 rounded-xl border border-indigo-900/50 space-y-5 shadow-md flex flex-col justify-center">
            <h3 className="font-bold text-white text-base flex items-center gap-2 border-b border-white/10 pb-3">
              <ShieldCheck className="w-5 h-5 text-blue-400" /> حلول مرنة للمشاريع الواعدة:
            </h3>
            <ul className="space-y-4 text-xs md:text-sm text-slate-200 font-light">
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>مواءمة كاملة مع تنظيمات هيئة السوق المالية.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>هيكلة مرنة لأسهم الموظفين والخيارات المستقبلية.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>حماية فكرية للمصنفات البرمجية والنماذج الصناعية.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <Award className="w-4 h-4 text-blue-400 shrink-0 mt-0.5" />
                <span>صياغة عقود تقديم الخدمات وشروط الاستخدام الرقمية.</span>
              </li>
            </ul>
          </div>

        </div>
      </section>

      {/* Grid: Scope of Services - Converted from Dark to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">حزمة الرعاية القانونية الشاملة للرياديين</h2>
            <p className="text-slate-500 text-sm md:text-base font-light max-w-xl mx-auto">من صياغة الفكرة الأولية وتأمين العقود وحتى التوسع وعقد صفقات الاستحواذ والاندماج</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {startupServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Regulatory Context Disclaimer / Tip - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <HelpCircle className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">نصيحة ريادية بشأن عقود الدخول في الاستثمار:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              عند التفاوض على شروط وثيقة الشروط الأساسية (Term Sheet) مع المستثمرين، يجب الالتفات الدقيق لبعض البنود المصيرية مثل بنود تصفية الأفضلية (Liquidation Preference) وحقوق مكافحة التخفيف (Anti-dilution). إن التوقيع المتسرع دون مراجعة محامٍ متخصص قد يحرم المؤسسين من ثمار جهودهم عند التخارج.
            </p>
          </div>
        </div>
      </section>

      {/* Call to Action Banner - Refactored Styles */}
      <section className="max-w-4xl mx-auto pb-20 px-4 text-center">
        <div className="inline-flex p-3 bg-slate-50 rounded-full text-indigo-950 border border-slate-100 shadow-sm mb-4">
          <FileSignature className="w-6 h-6 text-blue-700" />
        </div>
        <h3 className="text-xl font-bold text-indigo-950 mb-2">هل تبحث عن انطلاقة قانونية آمنة لمشروعك؟</h3>
        <p className="text-slate-500 text-sm max-w-xl mx-auto mb-6 font-light">
          شاركنا طبيعة مشروعك الناشئ والتحديات التي تواجهها، ودع فريقنا المتخصص يتولى بناء الإطار التشريعي والحمائي الذي يضمن لك نمواً مستداماً.
        </p>
        <button 
                  onClick={() => openWhatsApp( "    طلب باقة الدعم القانوني للشركات الناشئة    ")}

        
        className="bg-indigo-950 text-white font-bold text-sm px-6 py-3 rounded-lg hover:bg-slate-900 transition-all duration-200 shadow-sm inline-flex items-center gap-2">
          طلب باقة الدعم القانوني للشركات الناشئة
          <ChevronLeft className="w-4 h-4" />
        </button>
      </section>

    </div>
  );
}